export const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZnJhbnJpb3MiLCJhIjoiY2pibXM5Z2k5M3I4dTMzbHB4NWJkanNyNSJ9.24SqQxgDaPDZMS2YT51AFA"


// WEBPACK FOOTER //
// ./src/.secrets.js